/**
 * =============================================================================
 * mp.js 
 * =============================================================================
 *
 * Entrypoint for all custom JS for this project. Any JS functionality should be
 * wrapped into Extension and placed in /scripts/vendor named
 * mp-extension-name.js.
 *
 * MP is our global object, attached to the window, with all utilities and
 * extensions
 * =============================================================================
 */

 var MP = { 
  Settings: {
    debug: false
  },
  PreInitCallbacks: [],
  PostInitCallbacks: [],

  Extensions: {}, 

  Globals: {
    templates: {
        notification: null
    }
  },

  // Simple cache for API requests
  Cache: new Map(),

  Utilities: { 
    isProductPage: function(){ 
      return document.querySelectorAll('.template-product').length > 0;
    },

    isCollectionPage: function(){
      return document.querySelectorAll('.template-collection').length > 0;
    },

    isCartPage: function(){
      return document.querySelectorAll('.template-cart').length > 0;
    },

    fetchConfig: function(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
      };
    },

    /**
     * Show a Bootstrap Alert
     * 
     * @param {String} type 
     * @param {String} content 
     * @param {String} icon 
     */
    alert: function(type = "primary", content = "<strong>This</strong> is an alert", icon = "", closeAfter = 5000) {
      let alert = document.querySelector("#alert-container > .alert");
      alert.className = `${alert.className.replace(/\balert-.+/g, '')} alert-${type}`;
      let alertContent = alert.querySelector(".alert-message");
      content = `<div>${content}</div>`;
      if(icon){
        content = `<i class="fs-4 me-2 ${icon}"></i>${content}`;
      }
      alertContent.innerHTML = content;
      alert.classList.add("show");
      setTimeout(() => {
        alert.classList.remove("show")
      }, closeAfter);
    },

    /**
     * Show a Bootstrap Toast
     * 
     * @param {String} type 
     * @param {String} content 
     * @param {String} icon 
     */
    toast: function(type = "success", content = "<strong>This</strong> is a toast!", icon = "") {
      // Get the template and clone it
      let container = document.querySelector("#toasts");
      let template = document.querySelector('#toast');
      let clone = template.content.firstElementChild.cloneNode(true);

      // Set the alert class, message and optional icon
      let wrapper = clone.querySelector("div:first-child");
      wrapper.className = `${wrapper.className} alert-${type}`;
      clone.querySelector(".toast-message").innerHTML = content;
      if(icon){
        clone.querySelector(".toast-icon").innerHTML = `<i class="fs-4 me-2 ${icon}"></i>`;
      }

      // Add to the DOM, and show
      container.appendChild(clone);
      let toast = new bootstrap.Toast(clone);
      toast.show();
    },

    formatMoney: function(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || this.money_format);
    
      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }
    
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
    
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      }
    
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    
      return formatString.replace(placeholderRegex, value);
    },

    toTitleCase(string){
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    },

    getStencilVariable: function(name) {
      return getComputedStyle(document.documentElement).getPropertyValue(`--📐-${name}`);
    },

    /**
     * Get keyed object of BS breakpoints and their pixel min-widths
     * 
     * @returns {Object} breakpoints
     */
    getBSBreakpoints: function() {
      const rootStyles = getComputedStyle(document.documentElement);
      return ['sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'].reduce((breakpoints, bp) => {
        breakpoints[bp] = parseInt(rootStyles.getPropertyValue(`--bs-breakpoint-${bp}`).trim(), 10);
        return breakpoints;
      }, { xs: 0 });
    },

    /**
     * Convert a rem value to pixels
     * 
     * @param {String|Number} rem 
     * @returns {Number}
     */
    remToPx: function(rem) {
      rem = parseFloat(rem); 
      return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    },

    /**
     * Convert a Bootstrap column class string (e.g. 'col-6 col-lg-4') to an
     * object keyed by breakpoint with the number of items per row.
     * 
     * @param {String} classString 
     * @returns {Object} itemsPerRow
     */
    colClassToItemsPerRow: function(classString) {
      const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl'];
    
      // Custom class mappings for your custom column classes. These should
      // match the custom width utility in theme.scss.
      const customClasses = {'⅒': 10, '⅛': 8, '⅕': 5 };
    
      // Default columns in the Bootstrap grid
      const defaultColumns = 12;
    
      // // Initialize items per row with defaults - in BS, a column with no class
      // // occupies the full row.
      const itemsPerRow = Object.fromEntries(breakpoints.map(bp => [bp, 1]));

      // Split the class string into individual classes
      const classes = classString.trim().split(" ")
      classes.forEach(cls => {
        const parts = cls.split('-');
        const bp = parts.length === 2 ? 'xs' : parts[1];

        // Handle standard Bootstrap classes (col-6, col-md-3, etc.)
        if (cls.startsWith('col-')) {
          const size = parseInt(parts.pop(), 10);
          if (size) {
            itemsPerRow[bp] = defaultColumns / size;
          }
        }
    
        // Handle custom classes (colx-⅒, colx-lg-⅛, etc.)
        if (cls.startsWith('colx-')) {
          const customSize = parts.pop();
          if (customClasses[customSize]) {
            itemsPerRow[bp] = customClasses[customSize];
          }
        }
      });
    
      // Ensure inheritance from smaller breakpoints
      for (let i = 1; i < breakpoints.length; i++) {
        const prevBp = breakpoints[i - 1];
        const currentBp = breakpoints[i];
    
        if (!classes.some(cls => cls.includes(`-${currentBp}`))) {
          itemsPerRow[currentBp] = itemsPerRow[prevBp];
        }
      }

      return itemsPerRow;
    }
  },

  Log: (...args) => MP.Settings.debug ? console.log(...args) : null,
  Warn: (...args) => MP.Settings.debug ? console.warn(...args) : null,
  Error: (...args) => MP.Settings.debug ? console.error(...args) : null,

  init: function() {
    this.hasLoaded = true;

    const urlParams = new URLSearchParams(window.location.search);
    this.Settings.debug = (urlParams.get('mpd') ? true : false) || window.theme.isDevelopment;

    var alertList = document.querySelectorAll('.alert');
    alertList.forEach(function (alert) {
      var alert = new bootstrap.Alert(alert);
    })

    document.addEventListener('full-cart:updated', mp_lazyload_setup); 

    // Run all pre-init callbacks registered before script was loaded 
    this.runPreInitCallbacks();

    // Call onReady method of all extensions once DOMContentLoaded event fired
    document.addEventListener("DOMContentLoaded", function() {
      MP.onReady();
      for (const [key, value] of Object.entries(MP.Extensions)) {
        if("onReady" in value){
          try {
            value.onReady(); 
          } catch (e) {
            console.error(e);
          }
        }
      }
    });

    // Call init method of all extensions straightaway
    for (const [key, value] of Object.entries(MP.Extensions)) {
      if("init" in value){
        try {
          value.init(); 
        } catch (e) {
          console.error(e);
        }
      }
    }

    // Run all post-init callbacks registered before script was loaded 
    this.runPostInitCallbacks();

    // Make all links with # in #MainContent to scroll to the href ID
    document.querySelectorAll("#MainContent a[href*='#']:not([data-hash-ignore])").forEach(element => {
      element.addEventListener("click", e => {
        document.querySelector(element.href).scrollIntoView({
          behavior: 'smooth'
        });
      });
    });
    
  },

  runPreInitCallbacks: function() {
    // Run all pre-init callbacks registered before script was loaded 
    while (this.PreInitCallbacks.length){
      try {
        this.PreInitCallbacks.shift().call();
      } catch (e) {
        console.error("[MP] Failed to run callback with error", e);
      }
    }
  },

  runPostInitCallbacks: function() {
    // Run all post-init callbacks registered before script was loaded 
    while (this.PostInitCallbacks.length){
      try {
        this.PostInitCallbacks.shift().call();
      } catch (e) {
        console.error("[MP] Failed to run post-init callback with error", e);
      }
    }
  },

  onReady: function() {

  }
}

export default MP;